import React from "react";
import { useQuery } from "react-query";
import TaskTile from "./components/TaskTile";
import { supabase } from "../../supabaseClient";
import CreateAGuide from "./components/CreateAGuide";
import { useAuth } from "../authentication/AuthContext";
import Layout from "../shared/Layout";
import StartAChat from "../chat/components/StartAChat";

export default function DraftTasks() {
  const { user } = useAuth();

  const fetchTasks = async () => {
    try {
      let { data: tasks, error } = await supabase
        .from("task_drafts")
        .select("user_id,title,description,tags,created_at,id,type")
        .eq("user_id", user?.id)
        .limit(10)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Error fetching tasks:", error);
      } else {
        return tasks;
      }
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  const {
    data: tasks,
    isLoading,
    isError,
  } = useQuery("task_drafts", fetchTasks, {
    enabled: !!user,
  });

  return (
    <Layout>
      <div className="mx-auto py-8">
        <div className="flex justify-between items-center mb-8 px-4 md:px-8">
          <h1 className="text-xl md:text-3xl font-bold">{`My Drafts (${
            tasks?.length || 0
          })`}</h1>
          <StartAChat />
        </div>
        {isLoading && (
          <div className="space-y-4 px-1 md:px-8">
            {Array.from({ length: 5 }, () => 0).map((x) => (
              <div
                className="skeleton h-40 w-full"
                key={x}
              ></div>
            ))}
          </div>
        )}
        {/* Question feed */}
        {!isLoading && tasks && (
          <div className="space-y-4 px-1 md:px-8">
            {tasks.map((task) => (
              <TaskTile
                key={task.id}
                task={task}
                draft={true}
              />
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}